import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { Permission } from "@/models";
import { usePermissions } from "@/features/auth";

import { type IGIREMenuItem } from "../models/router.types";

import { menuItems } from ".";

/**
 * Hook para filtrar el árbol de item en el menú principal, según el attributo de permiso del usuario logeado
 */
export const useMenu = () => {
  const actionsAllowed = usePermissions((state) => state.actionsAllowed);
  const isAllowedTo = usePermissions((state) => state.isAllowedTo);
  const location = useLocation();

  const allowedItems = useMemo(() => {
    return _filterAllowedMenuItem(menuItems, isAllowedTo);
    //  this depeends on permissions in a indirect way
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllowedTo, actionsAllowed]);

  // Marca items con active si tiene alguna seccion hija activada
  const allowedItemsAndSelected: IGIREMenuItem[] = useMemo(() => {
    return (
      allowedItems?.map((item) => {
        return {
          ...item,
          active: location.pathname.includes(item.data ?? ""),
        };
      }) ?? []
    );
  }, [allowedItems, location]);

  return allowedItemsAndSelected ?? [];
};

/**
 * Funcion pura y recursiva para filtrar items del menu permitidos
 */
const _filterAllowedMenuItem = (
  menuItems: IGIREMenuItem[] | undefined,
  checkerF: (permissions: Permission[], exhaustive?: boolean) => boolean,
): IGIREMenuItem[] | undefined => {
  if (!menuItems) {
    return;
  }

  // filtra items root
  const allowed = menuItems.filter((mItem) => {
    if (mItem.disabled === true) {
      return false;
    }

    if (!mItem.permission) {
      return true;
    }

    const must = Array.isArray(mItem.permission.must)
      ? mItem.permission.must
      : [mItem.permission.must];

    return checkerF(must, mItem.permission.exhaustive);
  });

  // filtra items hijos
  return allowed.map((mItem) => {
    return {
      ...mItem,
      items: _filterAllowedMenuItem(mItem.items, checkerF),
    } as IGIREMenuItem;
  });
};
